import {getLatestOtherTicketsValidityEndUnix} from '../basicTicket/ticketValidity/validityValidation';

export const getInitialValues = (ticket, t = val => val, couponTicketClubs = [], tickets = null) => {
    const imgData = JSON.parse(ticket.imgData || '{}');
    const resolvedStartDate = getLatestOtherTicketsValidityEndUnix(tickets, ticket.tid ?? null) ?? null;
    let details = {
        active: ticket.tid ? ticket.active : 1,
        title: ticket.title ? ticket.title : '',
        color: ticket.color ? ticket.color : '76d6e8',
        description: ticket.description ? ticket.description && JSON.parse(ticket.description) : '',
        course: ticket.course? ticket.course :  {startDate: '', endDate: '',meetings: []},
        prices: ticket.prices?.length ? ticket.prices : [{price:'0'}],
        limit: ticket.limit ? ticket.limit : 10,
        // preSale: (ticket.preSale&&ticket.preSale[0]) ? ticket.preSale[0] :{tpsid:0,discount:0,discountType:'sum'},
        users: ticket.users?.length ? ticket.users : [],
        startDiscount: '',
        endDiscount: '',
        imgData: {image: imgData?.path || '', imageId: imgData?.imageId, credit: {creditName: imgData?.creditName, license: imgData?.license, alt:imgData?.alt}},
        // monthNumber:0
        location: {...ticket.location,
            skipHolidays:ticket.location?.skipHolidays? ticket.location.skipHolidays :'Jewish',
            locationMap:(typeof ticket.location?.locationMap ==='string')?JSON.parse(ticket.location.locationMap):ticket.location?.locationMap
        },
        draft:ticket?.draft || 0,
        // Validity fields (extracted from nested validity object)
        startDateActive: ticket.validity?.startDateActive === 1,
        startDate: ticket.validity?.startDate ?? resolvedStartDate,
        startTime: ticket.validity?.startDate ?? resolvedStartDate,
        endDateActive: ticket.validity?.endDateActive === 1,
        endDate: ticket.validity?.endDate ?? null,
        endTime: ticket.validity?.endDate ?? null,
        displayBeforeSale: ticket.validity?.preActive === 1,
        displayAfterSale: ticket.validity?.postActive === 1,
    };

    let extras = {
        extras: ticket.extras?.length ? ticket.extras : []
    };
    const isMemberLimit = ticket.crowd?.limit === -1 ? true : false;
    let payments = {
        text: ticket.text ? ticket.text : '',
        payments: ticket.payments ? ticket.payments : {},
        crowd: ticket.crowd ? {
            ...ticket.crowd,
            isMemberLimit,
            crid: ticket.crowd.crid || null,
            limit: ticket.crowd.limit === -1 ? null : ticket.crowd.limit
        } : {},
        committees: (() => {
            if(ticket.committees && ticket.committees.length > 0) {
                return ticket.committees;
            }
            if(couponTicketClubs && couponTicketClubs.length > 0 && ticket.tid) {
                const filteredClubs = couponTicketClubs.filter((club) =>
                    club.tid === ticket.tid
                );
                return filteredClubs.map((club) => ({
                    clubId: club.clubId,
                    title: club.title,
                    ticketToken: club.ticketToken || '',
                    tid: club.tid,
                    cid: club.cid
                }));
            }
            return [];
        })(),
    };
    payments={...payments, payments:{...payments.payments, extraException:!!payments.payments.extraException}};

    const initialCourseField = {
        active: true,
        required: true,
    };

    const customFields = {
        courseFields: ticket.tid ? ticket.ticketFieldsCustom :
            [{
                title: t('firstName'),
                type: 'firstName',
                ...initialCourseField
            },
            {
                title: t('lastName'),
                type: 'lastName',
                ...initialCourseField
            }]
    };

    return {extras, payments, details, customFields};
};
